import BaseUtil from "../../util/BaseUtil";
import AppContext from "../../application/AppContext";

const type = `@@ActionType/UPDATE@${__filename}`;


export const HzwjwGovLetterStatus = {
    false: {
        code: "NOT_RECEIVED",
        display: "未接收",
        color: "#FF8B00",
    },
    true: {
        code: "RECEIVED",
        display: "已接收",
        color: "#34C1A2",
    },
};

export const SwjwGovLetterStatus = {
    0: {
        code: "0",
        display: "未接收",
        color: "#FF8B00",
    },
    1: {
        code: "1",
        display: "已接收",
        color: "#34C1A2",
    },
};


const initState = {
    pageable: {
        current: 1,
        limit: 20,
    },
    loading: false,
    selectedHospitalIds: ["ALL"],
    selectedDistrictIds: ["ALL"],
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);
export {
    update,
    reset,
};
export default viewModel;
